import _get from 'lodash/get';
import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';

const getPersonalizedContent = (requestParams) => {
    try {
        const config = {
            url: `/content-aggregator/shared-components/zones/PersonalizedContent`,
            apiHost: apiHosts.content,
            params: requestParams,
            excludeVersion: true,
            isXCloudHeaderRequired: true,
        };

        return RestClient.get(config)
            .then((json) => ({
                ...json,
                data: {
                    ...json.data,
                    CacheControl: __SERVER__
                        ? _get(json, "headers._headers['x-yoda-cache-control']", null)
                        : null,
                    status: json.status || null,
                },
            }))
            .catch((error) => {
                console.log(`Personalized Content request failed ${error}`);
            });
    } catch (error) {
        return error;
    }
};

export default getPersonalizedContent;
